export default __webpack_public_path__ + "static/media/careteam_patient_records_calender.ae2e52f0.svg";